export default {
  row1: [
    {
      column: "column1",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exporterProductDocType",
            label: "Doc Type",
            component: "text-field",
          },
        ],
        row2: [
          {
            name: "exporterProductDocAgencyCode",
            label: "Agency Code",
            component: "text-field",
            width: "100%",
          },
        ],
        row3: [
          {
            name: "exporterProductDocDocumentName",
            label: "Document Name",
            component: "text-field",
            width: "100%",
          },
        ],
      },
    },
    {
      column: "colum2",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exporterProductDocDescription",
            label: "Description",
            component: "text-field",
            width: "100%",
          },
        ],
        row2: [
          {
            name: "exporterProductDocAgencyName",
            label: "Agency Name",
            component: "text-field",
            width: "100%",
          },
        ],
      },
    },
  ],
};
